<template>
  <section class="file-upload">
    <div class="file-upload__wrapper">
      <b-upload :disabled="disabled" v-model="file" @input="uploadFile" drag-drop :accept="accept">
        <a :disabled="disabled" class="ws-button file-upload-button button is-primary is-small is-size-5">
          <span>{{ buttonLabel }}</span>
          <span class="file-download-button__spinner" v-if="isUploadPending">
          &nbsp;  <ws-spinner />
          </span>
        </a>
      </b-upload>
    </div>
  </section>
</template>

<script>
export default {
  name: 'FileUpload',
  props: {
    label: {
      type: String
    },
    buttonLabel: {
      type: String,
      default: 'Загрузить файл'
    },
    isShowFileName: {
      type: Boolean,
      default: true
    },
    isShowFileSize: {
      type: Boolean,
      default: true
    },
    itemGuid: {
      type: String,
      default: null
    },
    accept: {
      type: String,
      default: null
    },
    category: {
      type: String,
      default: null
    },
    pathUrl: {
      type: String,
      default: '/api/dpws/general-files/add/category/'
    },
    disabled: Boolean
  },
  data () {
    return {
      file: null,
      isUploadPending: false
    }
  },
  methods: {
    async uploadFile (file) {
      this.isUploadPending = true
      const formData = new FormData()
      formData.append('file', file, file.filename)
      try {
        const url = `${__config.api_url}${this.pathUrl}${this.category}/${this.itemGuid}`
        console.log(this.pathUrl)
        const { data: files } = await this.$http.post(url, formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        }).then(response => response.data)
        this.$emit('uploaded', files, this.category)
      } catch (e) {
        this.$buefy.toast.open({
          message: this.$t(`Что-то пошло не так :(`),
          type: 'is-danger'
        })
      }
      this.isUploadPending = false
    }
  }
}
</script>

<style lang="scss">
  .file-upload {
    .upload {
      display: block;
      width: 100%;
    }
    &-button {
      width: 100%;
    }
  }
</style>
